<div class="fl-wrap p-0">
    <div class="fl-wrap full-height tabs-act">
        <div class="filter-sidebar-header fl-wrap mt-1 pt-1 pb-0 mb-0">
            <ul class="tabs-menu fl-wrap no-list-style">
                <li [ngClass]="toggleClass ? '' : 'current'">
                    <a href="javaScript:void(0);" (click)="filterTabEvent()"> <i class="fal fa-sliders-h"></i> Filters
                    </a>
                </li>
                <li [ngClass]="toggleClass ? 'current' : ''">
                    <a href="javaScript:void(0);" (click)="filterTabEvent()"> <i class="fal fa-image"></i>Premium
                        Advertising </a>
                </li>
            </ul>
        </div>
        <div class="p-4 filter-sidebar full-height">
            <!--tabs -->
            <div class="tabs-container fl-wrap">
                <!--tab -->
                <div class="tab">
                    <div id="filters-search" class="tab-content first-tab custom-form mb-0"
                        [ngClass]="toggleClass ? 'd-none' : 'd-block'">
                        <form [formGroup]="form"> 
                            <!-- listsearch-input-item-->
                            <div class="listsearch-input-item textbox">
                                <input formControlName="name" [(ngModel)]="filterCriteria.name" type="text" class="search mb-0" placeholder="Search products.." />
                            </div>
                            <!-- listsearch-input-item end-->

                            <!-- listsearch-input-item-->
                            <div class="listsearch-input-item">
                                <select class="form-select" formControlName="category" [(ngModel)]="filterCriteria.category" (change)="selectSubCategory($event)">
                                    <option [value]="null">-- Select Category --</option>
                                    <option *ngFor="let category of categories" [value]="category.id">
                                        {{ category.name }}
                                    </option>
                                </select>
                            </div>
                            <!-- listsearch-input-item end-->
                            <!-- listsearch-input-item-->
                            <div class="listsearch-input-item">
                                <select class="form-select" formControlName="subCategory" [(ngModel)]="filterCriteria.subCategory" >
                                    <option [value]="null">-- Select Sub Category --</option>
                                    <option *ngFor="let subcategory of subCategories" [value]="subcategory.id">
                                        {{ subcategory.name }}
                                    </option>
                                </select>
                            </div>
                            <!-- listsearch-input-item end-->
                            <!-- listsearch-input-item-->
                            <div class="listsearch-input-item">
                                <select class="form-select" formControlName="country" [(ngModel)]="filterCriteria.country">
                                    <option [value]="null">-- Select Your Country --</option>
                                    <option value="IN"> India </option>
                                    <option *ngFor="let country of countries;" [value]="country.value">
                                        {{ country.displayValue }}
                                    </option>
                                </select>
                            </div>
                            <!-- listsearch-input-item end-->
                            <!-- listsearch-input-item-->
                            <div class="listsearch-input-item">
                                <select class="form-select" formControlName="state" [(ngModel)]="filterCriteria.state">
                                    <option [value]="null">-- Select Your State --</option>
                                    <option *ngFor="let state of states" [value]="state.value">
                                        {{ state.displayValue }}
                                    </option>
                                </select>
                            </div>
                            <!-- listsearch-input-item end-->
                            <!-- listsearch-input-item-->
                            <div class="listsearch-input-item">
                                <select formControlName="city" class="form-select" [(ngModel)]="filterCriteria.district">
                                    <option [value]="null">-- Select Your City --</option>
                                    <option *ngFor="let city of cities" [value]="city.value">
                                        {{ city.displayValue }}
                                    </option>
                                </select>
                            </div>
                            <!-- listsearch-input-item end-->
                            <div class="clearfix"></div>
                            <!-- listsearch-input-item-->
                            <div class="w-100 float-start mb-1">
                                <button class="w-100 btn btn-primary" type="submit" (click)="applyFilter()"><i class="far fa-search"></i><span>Search</span></button>
                                <!-- <button class="w-100 btn btn-primary" type="button" (click)="onClickAllSearch(name.value, category.value, subCategory.value, country.value, state.value, city.value)"><i class="far fa-search"></i><span>Search</span></button> -->
                            </div>
                            <!-- listsearch-input-item end-->
                            <div class="clear-filter-btn w-100" (click)="reset()" title="Reset to visible all list"><i class="far fa-redo"></i> Reset Filters</div>
                        </form>
                    </div>
                </div>
                <!--tab end-->
                <!--tab -->
                <div class="tab">
                    <div id="category-search" class="tab-content" [ngClass]="toggleClass ? 'd-block' : 'd-none'">
                        <a  *ngFor="let ads of businessAds;" title="Click here" class="category-carousel-item fl-wrap full-height checket-cat"
                            routerLinkActive="active" [routerLink]="['/business-details', ads.businessName | businessSlug]">
                            <div class="listing-item-grid">
                                <div class="bg" [ngStyle]="{'background-image': ' url('+serverImgUrl +'adsImages/'+ ads.adsImageURL+')'}"></div>
                                <div class="d-gr-sec"></div>
                                <div class="listing-counter color2-bg">
                                    <span><i class="fas fa-map-marker-alt"></i> {{ads.businessCity}} | {{ads.adsDistrict}}, </span>{{ads.adsState}} | {{ads.adsCountry}}
                                    <a href="{{ads.facebookURL}}" class="ms-1 text-white" target="_blank" title="Facebook"><i class="fab fa-facebook"></i></a>
                                    <a href="{{ads.twitterURL}}" class="ms-1 text-white" target="_blank" title="Twitter"><i class="fab fa-twitter"></i></a>
                                    <a href="{{ads.instagramURL}}" class="ms-1 text-white" target="_blank" title="Instagram"><i class="fab fa-instagram"></i></a>
                                </div>
                                <div class="listing-item-grid_title">
                                    <h3><a routerLinkActive="active" [routerLink]="['/business-details', ads.businessName | businessSlug]" title="{{ads.adsTitle}}"> {{ads.adsTitle | shorten: 50: '...'}} </a></h3>
                                    <p class="mb-0 mp-0">{{ads.businessName | shorten: 30: '...'}}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <!--tab end-->
            </div>
            <!--tabs end-->
        </div>
    </div>
</div>
<div class="clearfix"></div>